import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"

export default function Serp() {
    const { loading, query, response: { products }, pageType } = useAppState()
    const foundProducts = products && products.total > 0
    const docCount = products?.total ?? 0
    const totalSummary = pageType === "category" ? `${docCount} products` : `${docCount} results for "${query.query}"`

    return (
        <div
            class="ns-serp ns-d-flex ns-flex-column ns-font-inherit"
            data-nosto-element="search"
        >
            {(foundProducts || (loading && foundProducts)) && (
                <>
                    <Sidebar />
                    <Toolbar mobile />
                    <header class="ns-PageHeader">
                        <div class="ns-Container">
                            <div class="ns-text-align-center">
                                <h1 class="ns-SectionHeader__Heading ns-Heading u-h1">Search</h1>
                                <div class="ns-SectionHeader__Description" data-nosto-element="totalResults">{totalSummary}</div>
                            </div>
                        </div>
                    </header>
                </>
            )}
            <div
                class="ns-CollectionMain ns-d-block ns-d-md-inline ns-w-100 ns-border-box"
                style={loading ? "position: relative;" : ""}
            >
                {foundProducts ? (
                    <>
                        {/* <SelectedFilters /> */}
                        {/* <Toolbar /> */}
                        <Products />
                        <BottomToolbar />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}

            </div>
        </div>
    )
}
